// @flow
export { default } from './PartnerPlaceholder';



// WEBPACK FOOTER //
// ./src/components/partner/PartnerPlaceholder/index.js